import React from 'react';
import TariffsSection from '../components/tariffs/TariffsSection';

const TariffsPage: React.FC = () => {
  return <TariffsSection />;
};

export default TariffsPage;
